type SetupClickToCopyButtonParams = {
  buttonElement: HTMLElement;
  textElement: HTMLElement;
  contentToCopy: string;
};

export default ({buttonElement, textElement, contentToCopy}: SetupClickToCopyButtonParams): void => {
  if (buttonElement) {
    buttonElement.addEventListener("click", event => {
      event.preventDefault()
      navigator.clipboard.writeText(contentToCopy)

      if (textElement && textElement.innerHTML != "Copied!") {
        const originalText = textElement.innerHTML
        textElement.innerHTML = "Copied!"
        setTimeout(() => { textElement.innerHTML = originalText }, 2000)
      }
    })
  }
}
